import LoginLayout from "../../layouts/login";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

// ----------------------------------------------------------------------

export default function Login() {
  return (
    <LoginLayout>
      <Authenticator hideSignUp socialProviders={[]} />
    </LoginLayout>
  );
}
